<template>
  <v-overlay :value="loading" z-index="1000">
    <div class="text-center">
      <v-progress-circular indeterminate size="64" />
      <div v-if="message" class="white--text mt-4 text-subtitle-1">{{ message }}</div>
    </div>
  </v-overlay>
</template>
<script>
export default {
  name: 'LoadingOverlay',
  props: {
    loading: { type: Boolean, required: true, default: false },
    message: { type: String, required: false, default: '' },
  },
}
</script>
